import {Vehicle} from "@commons/models/domain/Vehicle";
import {VehicleControlIndicator} from "@commons/models/domain/VehicleControlIndicator";
import {Driver} from "@commons/models/domain/Driver";

export class VehicleIndicatorsProcessor {

  public setVehiclesIndicators(
    updatedData: any,
    vehicle: Vehicle,
    driversDict: Map<number, Driver>,
    driverElectronicIdToDriverIdDict: Map<string, number>) {

    const driverId = updatedData.Data.DI;

    vehicle.St = updatedData.Data.St;
    if (updatedData.Data.LP) {
      vehicle.LastPositionLat = updatedData.Data.LP.Lat;
      vehicle.LastPositionLon = updatedData.Data.LP.Lon;
    }

    this.setVehiclePosition(updatedData, vehicle);

    if (driverId) {
      const driver = driversDict.get(driverId);
      if (driver) {
        vehicle.LastDriver = driver;
        vehicle.DR = driverId;
        if (driver.Status !== vehicle.St) {
          driver.Status = vehicle.St;
        }
      }
    }

    vehicle.ControlIndicators = vehicle.ControlIndicators ?? [];
    for (let i = updatedData.Data.Pr.length - 1; i >= 0; i--) {
      const updatedIndicator = updatedData.Data.Pr[i];
      if (updatedIndicator == null)
        continue;

      let indicator = vehicle.ControlIndicators.find(i => i.Id == updatedIndicator.ID);
      if (indicator == null) {
        indicator = {} as VehicleControlIndicator;
        vehicle.ControlIndicators.push(indicator);
      }

      indicator.LV = {V: updatedIndicator.V, T: updatedIndicator.T};
      if (indicator.Tp === 1000) {
        // status
        vehicle.St = indicator.LV.V;
        if (indicator.LV.T) {
          vehicle.LastUpdated = indicator.LV.T;
          vehicle.LastUpdatedFrom = 'WS_DATA_1_STATUS';
        }

      } else if (indicator.Tp === 1001) {
        // kierunek
        vehicle.VehicleAngle = indicator.LV.V;
      } else if (indicator.Tp === 23) {
        // kierowca
        const driverId = driverElectronicIdToDriverIdDict.get(indicator.LV.V);
        if (driverId) {
          vehicle.LastDriver = JSON.parse(JSON.stringify(driversDict.get(driverId)));
        }
      } else if (indicator.Tp === 1003) {
        vehicle.ES = indicator.LV.V;
      }
    }
  }

  private setVehiclePosition(updatedData: any, vehicle: Vehicle): void {
    const location = vehicle.LL;

    if (location) {
      const lat = parseFloat((updatedData.Data.LP.Lat || ''));
      const lon = parseFloat((updatedData.Data.LP.Lon || ''));
      location.Lt = lat;
      location.Ln = lon;
      vehicle.LL = location;
    }
  }

}
